import { BranchModel } from '@shared/models/branch.model';
import { RestaurantModel } from '@shared/models/restaurant.model';

export function getCurrentContextIds() {
  const restaurant: RestaurantModel | null = JSON.parse(localStorage.getItem('restaurant') ?? 'null');
  const branch: BranchModel | null = JSON.parse(localStorage.getItem('branch') ?? 'null');

  return {
    restaurantId: restaurant?.id,
    branchId: branch?.id,
  };
}
